import React from "react";

import { useAppSelector } from "../../reducers";
import { defaults } from "../defaults";
import { renderErrorMessageTemplate } from "../utils";

interface IProps {
    tags: string;
    message?: string;
}

const buildFormattedMessage = (
    tags: string,
    message: string,
): React.ReactNode => {
    tags = tags || "error";
    return (
        <li className={`messages__item ${tags}`}>
            <div className="messages__item__content l-capped-width">
                <p>
                    <span dangerouslySetInnerHTML={{ __html: message }}></span>
                </p>
            </div>
        </li>
    );
};

export const MessageBanner = (props: IProps): React.ReactNode => {
    const checkoutState = useAppSelector((state) => state.checkout || defaults);
    const payment_error = checkoutState.data.payment_error;
    const message = props.message ? props.message : payment_error;
    const encodedBasketID = checkoutState.data.basket
        ? checkoutState.data.basket.encoded_basket_id
        : "";
    const orderID = checkoutState.data.order
        ? checkoutState.data.order.number
        : "";

    const msg = renderErrorMessageTemplate(message, {
        basketID: encodedBasketID,
        orderID: orderID,
    });
    return (
        <aside
            className="messages l-full-width"
            style={msg ? {} : { display: "none" }}
        >
            <ul className="messages__list">
                {buildFormattedMessage(props.tags, msg)}
            </ul>
        </aside>
    );
};
